import React from "react";
import { useEffect, useState } from "react";
import { Mode } from "@/enum";
import { UserContext } from "@/types/user";
import { OPENSEA_URL } from "@/constants/url";

const { Countdown, Info } = Mode;

interface HeaderProps {
  whitelistEndTime: string | number | Date;
  mode: Mode;
  onModeChange: (mode: Mode) => void;
  user: UserContext | undefined;
}

const Header: React.FC<HeaderProps> = ({
  whitelistEndTime,
  mode,
  onModeChange,
  user,
}: HeaderProps) => {
  const [isWhitelistOver, setIsWhitelistOver] = useState(false);

  useEffect(() => {
    const end = new Date(whitelistEndTime).getTime();

    const update = () => {
      const now = Date.now();
      setIsWhitelistOver(now >= end);
    };

    update();
    const t = setInterval(update, 1000);
    return () => clearInterval(t);
  }, [whitelistEndTime]);

  return (
    <header className="header">
      <div className="user-wrapper">
        {user && (
          <>
            <div className="ava">
              <img src={user.pfpUrl} alt="" />
            </div>
            <p className="fid">FID: {user.fid}</p>
          </>
        )}
      </div>

      <div className="button-wrapper">
        <button
          className="button-flat nav-button"
          onClick={() => {
            if (isWhitelistOver) window.open(OPENSEA_URL, "_blank");
            else onModeChange(Countdown);
          }}
          disabled={mode === Countdown && !isWhitelistOver}
        >
          {isWhitelistOver ? "OpenSea" : "Mint Countdown"}
        </button>
        <button
          className="button-flat nav-button"
          disabled={mode === Info}
          onClick={() => onModeChange(Info)}
        >
          Mint Info
        </button>
      </div>
    </header>
  );
};

export default Header;
